import { render } from "./harvesterhci.io.management.cluster.vue?vue&type=template&id=b13030e8&scoped=true"
import script from "./harvesterhci.io.management.cluster.vue?vue&type=script&lang=js"
export * from "./harvesterhci.io.management.cluster.vue?vue&type=script&lang=js"

import "./harvesterhci.io.management.cluster.vue?vue&type=style&index=0&id=b13030e8&lang=scss&scoped=true"

import exportComponent from "../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b13030e8"]])

export default __exports__